var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-simplePage-detail"},[_c('a-card',{attrs:{"bordered":false}},[_vm._v("detail")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }